import React from "react";
import PropTypes from "prop-types";
import { Card } from "antd";
import CompatibleList from "../../common/compatible-list";
import { toPatentDetailLink, toDateString } from "../../../helpers/converters";
import { orderBy } from "lodash";

const PatentFamily = props => {
  const dataSource = orderBy(props.data.family_members, "publication_date", "asc");
  const columns = [
    {
      title: "Publication Number",
      dataIndex: "publication_number",
      width: 200,
      render: toPatentDetailLink
    },
    {
      title: "Publication Date",
      dataIndex: "publication_date",
      width: 150,
      render: val => toDateString(val)
    }
  ];
  const tableScroll = {
    x: 800,
    y: 360 // match height of component on its left
  };
  return (
    <Card title={`Family Members (${dataSource.length})`}>
      <CompatibleList dataSource={dataSource} columns={columns} rowKey="publication_number" size="small" pagination={false} scroll={tableScroll} />
    </Card>
  );
};

PatentFamily.propTypes = {
  data: PropTypes.object.isRequired
};

export default PatentFamily;
